import { NgModule } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterModule,
  Routes
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { ProductAddComponent } from './components/add/product-add.component';
import { ProductEditComponent } from './components/edit/product-edit.component';
import { ProductListComponent } from './components/list/product-list.component';
import { ProductViewComponent } from './components/view/product-view.component';
import { ProductService } from './service/product.service';

export class ProductRoutingStates {
  public static readonly LIST = {
    url: 'product'
  };
  public static readonly VIEW = {
    url: `${ProductRoutingStates.LIST.url}/:id/view`
  };
  public static readonly ADD = {
    url: `${ProductRoutingStates.LIST.url}/add`
  };
  public static readonly EDIT = {
    url: `${ProductRoutingStates.LIST.url}/:id/edit`
  };
}

/**
 * TODO: verify why using this causes route error. Maybe a service depndency not injected?
 */
class GetProductResolver implements Resolve<any> {
  constructor(private productService: ProductService, private router: Router) {}

  /**
   * Get the List of Tags used in Several Views
   * @param route
   */
  resolve(route: ActivatedRouteSnapshot): Observable<any> | boolean {
    const productId = route.params['id'];
    return this.productService.getProductById(productId);
  }
}

export const ProductRoutes: Routes = [
  {
    path: ProductRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Product List'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR, Groups.ASSET_VIEWER]
    },
    component: ProductListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ProductRoutingStates.VIEW.url,
    data: {
      page: {
        title: 'Product View'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR, Groups.ASSET_VIEWER]
    },
    component: ProductViewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ProductRoutingStates.ADD.url,
    data: {
      page: {
        title: 'Product Add'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: ProductAddComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ProductRoutingStates.EDIT.url,
    data: {
      page: {
        title: 'Product Edit'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: ProductEditComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(ProductRoutes)]
})
export class ProductRoutingModule {}
